import { render } from "./SuccessStoriesPage.vue?vue&type=template&id=a348ac74&ts=true"
import script from "./SuccessStoriesPage.vue?vue&type=script&lang=ts"
export * from "./SuccessStoriesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__